import { Select } from "antd";
import styled from "styled-components";

const StyledSelect = styled(Select)`
  border: none;
  && {
    width: 200px;
    padding-left: 8px;
    border: none;
  }
`;

export function DropDownComponent({
  placeHolder,
  showSearch = false,
  mode,
  loading = false,
  options = [],
  onChange = (value) => {},
}) {
  return (
    <StyledSelect
      mode={mode}
      showSearch={showSearch}
      size="middle"
      placeholder={placeHolder}
      optionFilterProp="children"
      loading={loading}
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
      filterSort={(optionA, optionB) =>
        optionA.children
          .toLowerCase()
          .localeCompare(optionB.children.toLowerCase())
      }
      onChange={(value) => {
        onChange(value);
      }}
      allowClear
      onClear={() => onChange(null)}
    >
      {options?.map((category) => (
        <Select.Option key={category.id} value={category.id}>
          {category.name}
        </Select.Option>
      ))}
    </StyledSelect>
  );
}
